import { type ProgressStatus, type StatusOption, type StreamFlag } from './BrowseCourses.types';

export const STATUS_OPTIONS: StatusOption[] = [
    'any_status',
    'available',
    'new_courses',
    'updated',
    'beta',
    'coming_soon',
    'elective',
];

export const PROGRESS_OPTIONS: ProgressStatus[] = ['not_started', 'in_progress', 'completed'];

// The stream property that each status filter checks. `any_status` and `available` have none.
export const STATUS_FLAGS: Partial<Record<StatusOption, StreamFlag>> = {
    new_courses: 'just_added',
    updated: 'just_updated',
    beta: 'beta',
    coming_soon: 'coming_soon',
    elective: 'elective',
};

// The Angular isMobile breakpoint
export const PHONE_QUERY = '(max-width: 767px)';

export const NEUTRAL_CAPSULE_CLASS_NAMES = { base: 'shrink-0' };

// The Button props of a selected or unselected filter option
export const toggleButtonProps = (selected: boolean) =>
    selected ? { color: 'primary' as const } : { variant: 'bordered-white' as const, color: 'slate-grey' as const };

// Matches the selected filter buttons. text-white on the base slot also colors the close button that
// Capsule renders for onClose.
export const SELECTED_CAPSULE_CLASS_NAMES = {
    base: 'bg-primary shrink-0 text-white',
    content: 'text-white font-semibold uppercase',
};

// Matches the unselected filter buttons (the bordered-white Button variant), for the grey page background
export const UNSELECTED_CAPSULE_CLASS_NAMES = {
    base: 'bg-white border border-solid border-slate-grey-300 shrink-0',
    content: 'text-slate-grey font-semibold uppercase',
};
